/* import __COLOCATED_TEMPLATE__ from './lsg-paginator.hbs'; */
import Component from '@glimmer/component';
import clsx from 'clsx';

const buttonClasses = (disabled) => clsx(
  disabled && 'disabled',
  'btn-icon',
);

/**
 * A pagination component following the lsg guidelines.
 */
class LsgPaginator extends Component {
  get backButtonClasses() {
    return buttonClasses(this.shouldNotAllowBackwardNavigation);
  }

  get forwardButtonClasses() {
    return buttonClasses(this.shouldNotAllowForwardNavigation);
  }

  /** @type {String} Human readable string that displays the paginator text (e.g. 1 - 15 of 100). */
  get pageControlsDisplayString() {
    const { currentPage, total, count, perPage } = this.args.paginationModel;

    const currentBeginIndex = (currentPage - 1) * perPage + 1;
    const finishIndex = currentBeginIndex + count - 1;
    const totalCount = total.toLocaleString();

    return `${currentBeginIndex} - ${finishIndex} of ${totalCount}`;
  }

  /**
   * When this returns true the back arrow will be disabled.
   *
   * @type {Boolean}
   */
  get shouldNotAllowBackwardNavigation() {
    return this.args.paginationModel.currentPage <= 1;
  }

  /**
   * When this returns true the forward arrow will be disabled.
   *
   * @type {Boolean}
   */
  get shouldNotAllowForwardNavigation() {
    const { currentPage, totalPages } = this.args.paginationModel;

    return currentPage >= totalPages;
  }
}

export default LsgPaginator;
